<template lang="pug">
.account-update-form
  v-form(ref="form")
    v-container
      v-layout
        v-flex
          v-text-field(
            :value="user.displayName"
            label="會員姓名"
            disabled)
      v-layout(wrap)
        v-flex(xs12)
          v-text-field(
            v-model="account"
            :counter="10"
            :error-messages="accountErrors"
            label="帳號(手機號碼)"
            outline
            @input="$v.account.$touch()"
            @blur="$v.account.$touch()")
        v-flex(xs12)
          v-text-field(
            v-model="password"
            :append-icon="show ? 'visibility' : 'visibility_off'"
            :type="show ? 'text' : 'password'"
            :counter="20"
            :error-messages="passwordErrors"
            label="密碼"
            outline
            @input="$v.password.$touch()"
            @blur="$v.password.$touch()"
            @click:append="show = !show")
        v-flex(xs12)
          v-text-field(
            v-model="password_2"
            :append-icon="show_2 ? 'visibility' : 'visibility_off'"
            :type="show_2 ? 'text' : 'password'"
            :counter="20"
            :error-messages="password_2Errors"
            label="確認密碼"
            outline
            @input="$v.password_2.$touch()"
            @blur="$v.password_2.$touch()"
            @click:append="show_2 = !show_2")
      form-actions(
        :loading="formMixin_loading"
        @cancel="$emit('cancel')"
        @submit="submit") {{ formMixin_message }}
    check-dialog(:open="checkDialog"
      title="會員帳號已開通"
      @check="$emit('update-succeed')")
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import {
  required,
  sameAs,
  minLength,
  maxLength,
  numeric
} from "vuelidate/lib/validators";
import length from "@/utils/validators/length";
import phoneNumberValidator from "@/utils/validators/phoneNumber";
import { formMixin } from "@/mixins";
import CheckDialog from "@/components/core/CheckDialog.vue";

export default {
  name: "AccountUpdateForm",
  mixins: [validationMixin, formMixin],
  validations: {
    account: { required, numeric, phoneNumber: phoneNumberValidator },
    password: { required, minLength: minLength(8), maxLength: maxLength(20) },
    password_2: { required, sameAs: sameAs("password") }
  },
  components: {
    CheckDialog
  },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      account: null,
      password: null,
      password_2: null,
      show: false,
      show_2: false,
      checkDialog: false
    };
  },
  computed: {
    accountErrors() {
      const errors = [];
      if (!this.$v.account.$dirty) return errors;
      !this.$v.account.required && errors.push("請輸入手機號碼");
      !this.$v.account.numeric && errors.push("請輸入正確的號碼");
      !this.$v.account.phoneNumber && errors.push("請輸入正確的號碼");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push("請輸入密碼");
      !this.$v.password.minLength && errors.push("最少輸入8碼");
      !this.$v.password.maxLength && errors.push("最多輸入20碼");
      return errors;
    },
    password_2Errors() {
      const errors = [];
      if (!this.$v.password_2.$dirty) return errors;
      !this.$v.password_2.required && errors.push("請確認密碼");
      !this.$v.password_2.sameAs && errors.push("兩次密碼不同");
      return errors;
    }
  },
  methods: {
    reset() {
      this.$refs.form.reset();
      this.$v.$reset();
    },
    async submit() {
      const res = await this.formMixin_submit(
        ["account", "password"],
        "post",
        `auth/${this.user.uid}`
      );

      if (res.succeed) {
        this.checkDialog = true;
      }
    }
  }
};
</script>
